import { Directive, Input } from '@angular/core';
import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[emailConfirm]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: EmailConfirmDirective,
    multi: true,
  }]
})
export class EmailConfirmDirective implements Validator {
  // @Input() form: FormGroup;
  constructor() {

  }
  validate(control: FormGroup): ValidationErrors {
    const emailControl = control.controls.email;
    const confirmEmailControl = control.controls.confirmEmail;
    if (!emailControl || !confirmEmailControl) {
      return null;
    }

    if ((confirmEmailControl.errors && !confirmEmailControl.errors.emailMismatch)) {
      return null;
    }

    if (emailControl.value !== confirmEmailControl.value) {
      return { 'emailMismatch': true };
    }
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }

}
